import { useRef } from 'react';

const MessagePopup = ({ isOpen, formData, onClose, onChange, onSubmit }) => {
  const popupRef = useRef(null);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    onClose();
  };

  const handlePopupClick = (e) => {
    e?.stopPropagation();
  };

  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 backdrop-blur-md bg-gray-900/60 flex items-center justify-center z-50"
    >
      <div
        ref={popupRef}
        onClick={handlePopupClick}
        className="bg-white rounded-2xl p-8 max-w-md w-full mx-4"
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-semibold text-gray-800">Send us a Message</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
            &times;
          </button>
        </div>
        
        <form onSubmit={onSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="messageName">
              Name
            </label>
            <input 
              type="text" 
              id="messageName" 
              name="name" 
              required 
              value={formData?.name}
              onChange={onChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500"
              placeholder="Enter your name"
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="messageEmail">
              Email
            </label>
            <input 
              type="email" 
              id="messageEmail" 
              name="email" 
              required 
              value={formData?.email}
              onChange={onChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500"
              placeholder="Enter your email"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="messagePhonenumber">
              Phone Number
            </label>
            <input 
              type="text" 
              id="messagePhonenumber" 
              name="phonenumber" 
              required 
              value={formData?.phonenumber}
              onChange={onChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500"
              placeholder="Enter your Phone Number"
            />
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="question">
              Question
            </label>
            <textarea 
              id="question" 
              name="question" 
              required 
              rows="4"
              value={formData?.question}
              onChange={onChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-amber-500"
              placeholder="What would you like to ask?"
            />
          </div>
          
          <button 
            type="submit" 
            className="w-full bg-gradient-to-br from-amber-600 to-orange-600 text-white font-semibold py-3 px-4 rounded-lg hover:from-amber-700 hover:to-orange-700 transition-colors"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default MessagePopup;